import React, { useState } from 'react';
import { translations } from '@/translations';
import ProfilesGrid from '@/components/profiles/ProfilesGrid';
import ProfilesHeader from '@/components/profiles/ProfilesHeader';
import AdminPageHeader from '@/components/layouts/AdminPageHeader';
import { Button } from '@/components/ui/button';
import { PieChart } from 'lucide-react';
import ProfileDistributionModal from '@/components/profiles/ProfileDistributionModal';

const ProfilesPage: React.FC = () => {
  const [showDistribution, setShowDistribution] = useState(false);

  // Force English language for profiles page
  const t = (key: string) => {
    const keys = key.split('.');
    let value: any = translations.en;
    for (const k of keys) {
      if (value && typeof value === 'object' && k in value) {
        value = value[k];
      } else {
        return key;
      }
    }
    return typeof value === 'string' ? value : key;
  };

  return (
    <>
      <AdminPageHeader title="Templates" />
      <div className="min-h-screen bg-background">
        <div className="max-w-6xl mx-auto px-6 py-12">
          <div className="mb-16 flex items-start justify-between gap-4">
            <div>
              <h1 className="text-2xl font-medium text-foreground mb-3 tracking-tight">
                {t('profiles.title')}
              </h1>
              <p className="text-muted-foreground text-base leading-relaxed max-w-2xl">
                {t('profiles.subtitle')}
              </p>
            </div>
            <Button
              onClick={() => setShowDistribution(true)}
              variant="outline"
              size="sm"
              className="flex items-center gap-2"
            >
              <PieChart className="h-4 w-4" />
              View Distribution
            </Button>
          </div>
          <ProfilesGrid />
        </div>

        <ProfileDistributionModal 
          open={showDistribution} 
          onOpenChange={setShowDistribution}
        />
      </div>
    </>
  );
};

export default ProfilesPage;
